// Local color constants for professional marketplace
export const marketplaceColors = {
  stone40: '#F5F1ED',
  stone50: '#ECE0D6',
  scale50: '#CBBAAB',
  concrete50: '#595552',
  divider: '#706256',
};
